import { Injectable, Injector } from '@angular/core';

import { UsersService } from './users.service';
import { BaseReportService } from './reportBase.service';
import type { TUser, IGetReportData } from '@shared/models';

@Injectable()
export class ReportUsersService extends BaseReportService implements IGetReportData {
    private usersService: UsersService;

    constructor(injector: Injector) {
        super(injector);
        this.usersService = injector.get(UsersService);
    }

    public async getReportData(): Promise<any> {
        const allRows: any[] = [];

        const users: TUser[] = await this.usersService.getAll();
        // .then((users: TUser[]) => {
        const sortedUsers = users.sort((a, b) => {
            const aName = a.firstName + ' ' + a.lastName;
            const bName = b.firstName + ' ' + b.lastName;
            if (aName < bName) return -1;
            if (aName > bName) return 1;
            return 0;
        });

        // Calculate data rows here.
        sortedUsers.forEach((user) => {
            const fullName = user.firstName + ' ' + user.lastName;
            const role = this.utilsService.getRoleTitle(user.role);
            const cellPhone = this.utilsService.formatPhoneNumberForDisplay(user.cellPhone);
            const email = user.email;
            const reportColValues: string[] = [fullName, role, cellPhone, email];
            const rowInfo = this.buildRowInfo(reportColValues, 'data');
            allRows.push(rowInfo);
        });

        allRows.push(undefined);
        const reportData = { 'data': allRows } as any;
        return reportData;
    }
}
